import clsx from 'clsx';
import React from 'react';

const numberOfFiles = (validationFiles) => {
    
    const unique = validationFiles.map( el => el.filePath).filter((item, i, ar) => ar.indexOf(item) === i);
    if(unique.length === 1){
        return '1 file'
    }
    return `${unique.length} files`;
    
}

const initialLetters = (title) => {
    const words = title.split(/\s+/);
    const initLetters =  words.map( el => el[0]).reduce( (final ,el) => final + el);
    return initLetters;
}

const ViolationsSection = (props) => {

    const{
        metricsData
    }=props;

    return(
        <div style={{marginTop: '2rem'}}>
            <div style={{fontWeight: '500', fontSize: '1.5rem'}}> Violations </div>
                {metricsData !== undefined &&
                    [...Array( Math.ceil(Object.keys(metricsData.violationsInfo.violations).length /3))].map((e, indexRow) => 
                        <div style={{marginTop: '4rem', display: 'flex', flexDirection: 'row', alignItems: 'stretch', justifyContent: 'space-between'}}>
                            { [...Array(3)].map( (o,indexColumn) =>
                                <ViolationCard metricsData={metricsData} validationKey = {Object.keys(metricsData.violationsInfo.violations)[indexRow*3 +indexColumn]}/>
                           )}
                        </div>
                    )
                }
                <div style={{marginTop: '2rem'}}>
                    &nbsp;
                </div>

        </div>
    )

}


const ViolationCard = (props) => {

    const{
        metricsData,
        validationKey
    } = props;

    return(
         metricsData !== undefined && metricsData.violationsInfo.violations[validationKey] !== undefined &&
            <div style={{width: '30%', minHeight:'100%'}}>
                <ViolationCardTitle title={metricsData !== undefined ? metricsData.violationsInfo.violations[validationKey].title : ''} />

                <div style={{ minHeight: '100%',position: 'relative', padding: '1vw',border: 'solid',borderWidth: '0px', borderBottomLeftRadius: '0.5rem', borderBottomRightRadius: '0.5rem', boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'}}>

                    <div style={{display: 'flex', flexDirection: 'column', marginTop: '1rem'}}>
                        <p style={{textAlign: 'justify'}}>{metricsData !== undefined ? metricsData.violationsInfo.violations[validationKey].explanation : ''}</p>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', marginTop: '1rem', marginBottom: '3rem'}}>
                        <span style={{display: 'flex', justifyContent: 'center'}}>Possible fixes found {metricsData !== undefined ? metricsData.violationsInfo.violations[validationKey].count : 0} time{metricsData !== undefined && metricsData.violationsInfo.violations[validationKey].count === 1 ? '' : 's'} in &nbsp; <span style={{color: '#0c4d82' }}> {metricsData!== undefined ? numberOfFiles(metricsData.violationsInfo.violations[validationKey].files) : '0 files'}</span></span>
                    </div>

                    <div style={{position : 'absolute',bottom: '2rem', width: '90%'}}>

                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                            <SeverityLabel 
                                title={metricsData !== undefined ? metricsData.violationsInfo.violations[validationKey].severity : ''}
                            />

                            <CategoryLabel 
                                category={metricsData !== undefined ? metricsData.violationsInfo.violations[validationKey].category : ''}
                            />

                        </div>
                    </div>

                </div>
            </div>
    )

}


const SeverityLabel = ({title}) => {

    const returnClasses = () => {
        if(title === 'Minor'){
            return clsx('fas fa-exclamation-triangle', 'fa-exclamation-triangleMinor');
        }
        if(title ==='Major'){
            return clsx('fas fa-exclamation-triangle', 'fa-exclamation-triangleMajor')
        }
        return clsx('fas fa-exclamation-triangle', 'fa-exclamation-triangleCritical');

    }

    return(
        title !== '' &&
            <div >
                <i className={ returnClasses()} />
                <span style={{marginLeft: '0.2rem'}}> {title}</span>
            </div>          
    )
            
}

const CategoryLabel = ({category}) => 
    (
            category !== '' &&
                <div style={{display: 'flex', flexDirection: 'row', backgroundColor: 'rgb(0, 87, 146)', padding: '0.2rem', paddingLeft: '0.4rem', paddingRight: '0.4rem', borderRadius: '16px'}}>
                    <div style={{borderRadius: '50%',backgroundColor: 'rgb(0, 60, 102)'}}>
                        <div style={{minWidth: '1.5rem',display: 'flex', alignItems: 'center', justifyContent: 'center',color: 'white',fontSize: '0.7rem',padding: '0.2rem'}}>
                            {initialLetters(category)}
                        </div>
                    </div>
                    <div style={{color: 'white', marginLeft: '0.5rem', fontSize: '0.9rem', marginRight: '0.2rem'}}>
                        {category}
                    </div>
                </div> 
    )





const ViolationCardTitle = ({title}) => 
    (
        <div style={{
            display: 'flex', 
            borderTopLeftRadius: '0.5rem', 
            borderTopRightRadius: '0.5rem',
            border: 'solid', 
            borderColor: '#0c4d82',
            flexDirection: 'row', 
            justifyContent: 'space-between', 
            backgroundColor: '#0c4d82', 
            color: 'white', 
            padding: '0.5rem',
            minHeight: '15%',
            boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'
            }}
            >
                <div> {title}</div>
            </div>
    )

export default ViolationsSection;